import {useState} from '@wordpress/element';
import {ColorPalette, BaseControl} from '@wordpress/components';

export default function ColorPicker({
										attributes,
										setAttributes,
										attributeName,
										label,
										help,
										onChange,
										clearable,
										colors
									}) {

	const [color, setColor] = useState(attributes[attributeName]);

	return (
		<BaseControl label={label} help={help} className="tiered-pricing-table__base-control">
			<ColorPalette
				style={{width: '100%'}}
				value={color}
				colors={colors}
				clearable={clearable}
				onChange={(color) => {
					let _attributes = [];

					_attributes[attributeName] = color;

					setAttributes(_attributes);
					setColor(color);

					onChange && onChange(color);
				}}
			/>
		</BaseControl>
	);
}
